import { NavLink, Outlet } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Building2, KeyRound, Tag, Receipt, ShieldCheck } from "lucide-react";
import { AvoraLogo } from "@/components/AvoraLogo";
import { useApp } from "@/context/AppContext";

const NAV = [
  { to: "/console", label: "Firms", icon: Building2, end: true, id: "firms" },
  { to: "/console/logins", label: "Logins", icon: KeyRound, id: "logins" },
  { to: "/console/pricing", label: "Pricing", icon: Tag, id: "pricing" },
  { to: "/console/payments", label: "Payments", icon: Receipt, id: "payments" },
  { to: "/console/audit", label: "Audit log", icon: ShieldCheck, id: "audit" },
];

const linkCls = ({ isActive }) =>
  `flex items-center gap-2 px-4 py-2 text-sm whitespace-nowrap transition-colors duration-200 border-b-2 ${
    isActive ? "border-amber-500 text-white" : "border-transparent text-slate-400 hover:text-white"
  }`;

export default function ConsoleLayout() {
  const { me } = useApp();
  return (
    <div className="min-h-screen bg-[#F6F4EE]">
      <header className="bg-[#0D2B45] text-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-10 pt-6 flex items-center gap-3">
          <AvoraLogo dark sub="Console · tenants, logins & billing" />
          <ShieldCheck className="h-5 w-5 text-amber-400 hidden sm:block" strokeWidth={1.5} />
          <div className="ml-auto flex items-center gap-4">
            <span className="hidden sm:inline text-xs font-mono text-slate-400" data-testid="console-email">{me?.email}</span>
            <UserButton />
          </div>
        </div>
        <nav className="max-w-[1400px] mx-auto px-3 sm:px-8 mt-5 flex overflow-x-auto" data-testid="console-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={linkCls} data-testid={`console-nav-${n.id}`}>
              <n.icon className="h-4 w-4" strokeWidth={1.5} />{n.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-[1400px] mx-auto px-5 sm:px-10 py-10">
        <Outlet />
      </main>
    </div>
  );
}
